import { ChevronDownIcon } from '@heroicons/react/24/outline';
import useNavigation from '../../../../hook/useNavigation';
import { useParams, useLocation } from 'react-router-dom';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { useEffect, useState } from 'react';
import { UFOODX_BASE_URL } from '../../../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderTypeOptions, setOrder, tableNumberAuto } from '../../../../store/reducers/order';
import { LoaderIcon, OrderTypeDeliveryIcon, OrderTypeDineInIcon, OrderTypePickupIcon } from '../../../../utils/svg';
import { removeCart } from '../../../../store/reducers/cart';
import { cleanText, encodeValue, isEmptyData } from "../../../../utils/helper";
import Confirmation from '../Confirmation';
import QRScanner from '../../QRScanner';
import ContinueTableNumber from '../../Outlet/ContinueTableNumber';
import InputTableNumber from '../../Outlet/InputTableNumber';
import { handleGetStoreDetail } from '../../../../store/reducers/outlet';

const Options = ({ onSelect }) => {
	const { type } = useParams();
	const { orderTypeOptions } = useSelector((store) => store?.order);
	const { pathname } = useLocation();
	const isUfoodX = pathname.includes(UFOODX_BASE_URL);

	return (
		<div className='m-4'>
			<div className='text-center font-semibold text-base text-gray-700 mb-4'>Pilih Tipe Pesanan</div>
			<div className='border-t-1 border-solid border-gray-200' />
			<div className='h-full flex flex-col my-2'></div>
			{orderTypeOptions?.map((t, index) => {
				const typeClean = cleanText(t?.av_name);
				if (typeClean === 'dinein' && !isUfoodX) return null;
				return (
					<div key={index} className={`border-1 border-gray-300 border-solid rounded-md flex justify-between px-2 py-2.5 mt-2 items-center`} onClick={() => onSelect(typeClean)}>
						<div className=''>
							<div className={`text-sm capitalize text-gray-900 font-semibold`}>{t?.av_name}</div>
							<div className='text-xs text-gray-400 pt-1 font-thin'>{t?.label ?? ''}</div>
						</div>
						<div className='flex'>
							<div className='pl-2'>
								<input
									id='type'
									type='radio'
									name='type'
									value={t?.av_name}
									checked={typeClean === type}
									onChange={() => { }}
									className={`${typeClean === type ? '!border-[var(--rose-violet)]' : '!border-gray-400'} after:!bg-[var(--rose-violet)] active:bg-white !focus:ring-0 !focus:bg-transparent !focus:shadow-none`}
								/>
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};

const Type = () => {
	const { type, slug } = useParams();
	const dispatch = useDispatch();
	const navigate = useNavigation();
	const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);
	const [isShowConfirmation, setIsShowConfirmation] = useState(false);
	const [selectedType, setSelectedType] = useState(null);
	const { details: outlet } = useSelector((store) => store?.outlet);
	const { orderTypeOptions, selectedOrderType, tableNumber } = useSelector((store) => store?.order);
	const user = useSelector((store) => store?.user);
	const { data: products } = useSelector((store) => store?.product);
	const { cart } = useSelector((store) => store?.cart);
	const { pathname } = useLocation();
	const parentRoute = pathname.substring(0, pathname.lastIndexOf('/')) || '/';
	const isUfoodX = pathname.includes(UFOODX_BASE_URL);

	const handleCheckProductAvability = (type) => {
		if (isEmptyData(cart?.item)) return true;

		const typeClean = cleanText(type);

		const isAllAllowed = cart.item.every((cartItem) => {
			const product = products?.find((p) => Number(p?.product_primary_id) === Number(cartItem?.product_primary_id));

			if (isEmptyData(product?.product_availability)) return true;

			return product.product_availability.some((availability) => cleanText(availability?.label) === typeClean);
		});

		return isAllAllowed;
	};
	const [showContinueTableModal, setShowContinueTableModal] = useState(false);
	const [isShowTableNumber, setIsShowTableNumber] = useState(false);
	const [isShowScanner, setShowScanner] = useState(false);
	const company = useSelector((store) => store?.company);

	const handleCloseBottomSheet = () => {
		setIsShowBottomSheet(false);
		setIsShowConfirmation(false);
		setSelectedType(null);
	};

	const handleSelectOption = (typeClean) => {
		const isAllowed = handleCheckProductAvability(typeClean);
		if (!isAllowed) {
      setSelectedType(typeClean);
			setIsShowConfirmation(true);
			return;
		}
		if (typeClean === 'dinein' && !isUfoodX) {
			handleNewTableFlow();
		}
		const selectedOrderType = orderTypeOptions.find((t) => cleanText(t?.av_name) === typeClean);
		dispatch(
			setOrder({
				selectedOrderType: selectedOrderType,
			}),
		);
		navigate.replace(`${parentRoute}/${typeClean}`);
		handleCloseBottomSheet();
	};

	const handleConfirm = () => {
		dispatch(
			removeCart({
				customerID: encodeValue(user?.customerID),
			}),
		).unwrap();
		const selectedOrderType = orderTypeOptions.find((t) => cleanText(t?.av_name) === selectedType);
		dispatch(
			setOrder({
				selectedOrderType: selectedOrderType
			})
		);

		if (selectedType === "dinein") {
			handleCloseBottomSheet();
			const isExpired =
				!tableNumber?.expired_at ||
				Date.now() > tableNumber?.expired_at;

			if (isExpired || isEmptyData(tableNumber?.table_number)) {
				handleNewTableFlow();
				return;
			}

			setShowContinueTableModal(true);
			return;
		}
		navigate.replace(`${parentRoute}/${selectedType}`);
		handleCloseBottomSheet();
	};

	const handleCancel = () => {
		handleCloseBottomSheet();
	};

	const handleGetOrderTypeOptions = () => {
		dispatch(
			getOrderTypeOptions({
				storeID: outlet?.storeID,
			}),
		);
	};

	const handleGetOutlet = async () => {
		dispatch(
			handleGetStoreDetail({
				storeID: slug,
				latitude: user?.latitude,
				longitude: user?.longitude,
			}),
		);
	};

	useEffect(() => {
		if(isUfoodX) return;

		handleGetOutlet();
	}, [])

	useEffect(() => {
		if (!outlet?.storeID) return;
		if (orderTypeOptions?.length > 0) return;
		handleGetOrderTypeOptions();
	}, [outlet?.storeID]);

	useEffect(() => {
		if (isEmptyData(orderTypeOptions) || !isUfoodX) return;
		if (isEmptyData(selectedOrderType) || cleanText(selectedOrderType?.av_name) !== cleanText(type)) {
			const selected = orderTypeOptions?.find(
				(t) => cleanText(t?.av_name) === cleanText(type)
			);
			dispatch(
				setOrder({
					selectedOrderType: selected
				})
			);
			dispatch(
				removeCart({
					customerID: encodeValue(user?.customerID),
				}),
			);
		}
	}, [type, orderTypeOptions, selectedOrderType])

	const formatTypeLabel = (type) => {
		if (!type) return "";

		if (type.toLowerCase() === "dinein") {
			return "Dine In";
		}

		return type.charAt(0).toUpperCase() + type.slice(1);
	};

	const handleNewTableFlow = async () => {
		await dispatch(setOrder({ tableNumber: {} }));
		if (isEmptyData(outlet?.dinein_qr_code)) {
			dispatch(
				tableNumberAuto({
					companyId: Number(isUfoodX ? company?.companyID : user?.companyID),
					outletId: Number(outlet?.storeID),
					brandId: Number(outlet?.brand_id),
				})
			);

			return;
		}

		if (outlet?.dinein_qr_code) {
			setIsShowTableNumber(true);
			return;
		}

		setShowScanner(true);
	};

	const handleCloseTableNumber = () => {
		setIsShowTableNumber(false);
	};

	return (
		<>
			<div className='flex justify-center items-center cursor-pointer rounded-md bg-white px-3 py-2 gap-1 font-semibold text-xs text-[var(--rose-violet)]' onClick={() => setIsShowBottomSheet(true)}>
				<>
					{type === 'delivery' && <OrderTypeDeliveryIcon />}
					{type === 'dinein' && <OrderTypeDineInIcon />}
					{type === 'pickup' && <OrderTypePickupIcon />}
					{formatTypeLabel(type)}
					<ChevronDownIcon className='w-3 h-auto text-[var(--rose-violet)]' strokeWidth={3} />
				</>
			</div>
			<BottomSheet key={'order-type-options'} open={isShowBottomSheet} onDismiss={handleCloseBottomSheet}>
				{isShowConfirmation ? <Confirmation onConfirm={handleConfirm} onCancel={handleCancel} /> : <Options onSelect={handleSelectOption} />}{' '}
			</BottomSheet>

			<InputTableNumber open={isShowTableNumber} onClose={handleCloseTableNumber} />
			{isShowScanner && <QRScanner onClose={() => setShowScanner(false)} />}
			{showContinueTableModal && (
				<ContinueTableNumber
					open={showContinueTableModal}
					onClose={() => setShowContinueTableModal(false)}
					onContinue={() => {
						setShowContinueTableModal(false);
						navigate.push(`${parentRoute}/dinein`);
					}}
					onChangeTable={async () => {
						setShowContinueTableModal(false);
						await handleNewTableFlow();
					}}
					tableNumber={tableNumber?.table_number}
				/>
			)}
		</>
	);
};

export default Type;
